export default __webpack_public_path__ + "static/media/2.291c7b95.png";